import React, { useState } from "react";
import { useAppDispatch } from "../../../store/hooks";
import { DeleteMachine, machinesActions } from "../../../store/Machines.store";
import ModalConfirm from "../../Utilities/ModalConfirm";
import { ReactComponent as Trash } from "../../../assets/trash.svg";

const BtnDeleteTask: React.FC<{ machineId: string ,email:string}> = ({ machineId, email }) => {
  const [showModal, setIsModalShown] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [toggalSvg, setToggleSvg] = useState(false);

  const removeTaskHandler = () => {
    dispatch(
      DeleteMachine(machineId, email, function () {
        dispatch(machinesActions.removeTask(machineId));
      })
    );
  };
  return (
    <>
      {showModal && (
        <ModalConfirm
          onClose={() => setIsModalShown(false)}
          text="This machine will be deleted permanently."
          onConfirm={removeTaskHandler}
        />
      )}
      <button
        onClick={() => setIsModalShown(true)}
        onMouseEnter={()=>{ setToggleSvg(!toggalSvg)}}
        onMouseOut={()=>{ setToggleSvg(!toggalSvg)}}
        title="delete machine"
        className="ml-2 transition hover:text-slate-700 dark:hover:text-slate-200"
      >
        {!toggalSvg ? (
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.5973 6.67597H22.6255C23.1761 6.67597 23.6043 7.10427 23.6043 7.65495V8.3586C23.6043 8.81751 23.2679 9.24581 22.8396 9.33759V23.8695C22.8396 24.8179 22.0443 25.5827 21.0655 25.5827H8.64693C7.66813 25.5827 6.90343 24.8179 6.90343 23.8695V9.33759C6.47521 9.24581 6.10815 8.81751 6.10815 8.3586V7.65495C6.10815 7.10427 6.56697 6.67597 7.11755 6.67597H10.1151V5.39104C10.1151 4.44265 10.8798 3.64722 11.8586 3.64722H17.8538C18.8326 3.64722 19.5973 4.44265 19.5973 5.39104V6.67597ZM17.8538 5.17689H11.8586C11.7057 5.17689 11.6139 5.26867 11.6139 5.39104V6.67597H18.0985V5.39104C18.0985 5.26867 18.0068 5.17689 17.8538 5.17689ZM9.13634 23.6247H20.6067C20.7291 23.6247 20.8208 23.4718 20.8208 23.3494V9.36819H8.89163V23.3494C8.89163 23.4718 8.9834 23.6247 9.13634 23.6247ZM11.4916 22.4928H11.3081C10.7575 22.4928 10.2987 22.0339 10.2987 21.4832V11.4791C10.2987 10.959 10.7575 10.5307 11.3081 10.5307H11.4916C12.0116 10.5307 12.4704 10.959 12.4704 11.4791V21.4832C12.4704 22.0339 12.0116 22.4928 11.4916 22.4928ZM14.948 22.4928H14.7951C14.2445 22.4928 13.7857 22.0339 13.7857 21.4832V11.4791C13.7857 10.959 14.2445 10.5307 14.7951 10.5307H14.948C15.4986 10.5307 15.9574 10.959 15.9574 11.4791V21.4832C15.9574 22.0339 15.4986 22.4928 14.948 22.4928ZM18.4044 22.4928H18.2515C17.7009 22.4928 17.2727 22.0339 17.2727 21.4832V11.4791C17.2727 10.959 17.7009 10.5307 18.2515 10.5307H18.4044C18.955 10.5307 19.4138 10.959 19.4138 11.4791V21.4832C19.4138 22.0339 18.955 22.4928 18.4044 22.4928Z"
              fill="#1D1E22"
            />
          </svg>
        ) : (
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.8011 6.68298H22.8292C23.3798 6.68298 23.8081 7.11129 23.8081 7.66197V8.36562C23.8081 8.82452 23.4716 9.25283 23.0434 9.34461V23.8765C23.0434 24.8249 22.2481 25.5897 21.2693 25.5897H8.85067C7.87186 25.5897 7.10717 24.8249 7.10717 23.8765V9.34461C6.67894 9.25283 6.31189 8.82452 6.31189 8.36562V7.66197C6.31189 7.11129 6.77071 6.68298 7.32128 6.68298H10.3189V5.39806C10.3189 4.44966 11.0836 3.65424 12.0624 3.65424H18.0576C19.0364 3.65424 19.8011 4.44966 19.8011 5.39806V6.68298ZM18.0576 5.18391H12.0624C11.9094 5.18391 11.8177 5.27569 11.8177 5.39806V6.68298H18.3023V5.39806C18.3023 5.27569 18.2105 5.18391 18.0576 5.18391ZM9.34007 23.6317H20.8105C20.9328 23.6317 21.0246 23.4788 21.0246 23.3564V9.37521H9.09537V23.3564C9.09537 23.4788 9.18713 23.6317 9.34007 23.6317ZM11.6953 22.4998H11.5118C10.9612 22.4998 10.5024 22.0409 10.5024 21.4902V11.4862C10.5024 10.9661 10.9612 10.5378 11.5118 10.5378H11.6953C12.2153 10.5378 12.6741 10.9661 12.6741 11.4862V21.4902C12.6741 22.0409 12.2153 22.4998 11.6953 22.4998ZM15.1517 22.4998H14.9988C14.4482 22.4998 13.9894 22.0409 13.9894 21.4902V11.4862C13.9894 10.9661 14.4482 10.5378 14.9988 10.5378H15.1517C15.7023 10.5378 16.1611 10.9661 16.1611 11.4862V21.4902C16.1611 22.0409 15.7023 22.4998 15.1517 22.4998ZM18.6081 22.4998H18.4552C17.9046 22.4998 17.4764 22.0409 17.4764 21.4902V11.4862C17.4764 10.9661 17.9046 10.5378 18.4552 10.5378H18.6081C19.1587 10.5378 19.6175 10.9661 19.6175 11.4862V21.4902C19.6175 22.0409 19.1587 22.4998 18.6081 22.4998Z"
              fill="#06B4FF"
            />
          </svg>
        )}
      </button>
    </>
  );
};

export default React.memo(BtnDeleteTask);
